import 'setimmediate';
import { format, createLogger, transports, type Logger } from 'winston';
import { formatISO } from 'date-fns';

interface LoggerConfig {
  label: string;
}

const formatMessage = (info: any): string => {
  const { label, timestamp, level, message } = info;
  const splat = info[Symbol.for('splat')];
  return `[${label}] ${timestamp} ${level}: ${message} ${splat !== undefined ? JSON.stringify(splat) : ''}`;
};

const consoleTransportOptions = ({ label }: LoggerConfig): transports.ConsoleTransportOptions => ({
  level: process.env.REACT_LOGGING_LEVEL ?? 'debug',
  format: format.combine(
    format.colorize({ all: true }),
    format.label({ label }),
    format.timestamp({
      format: () => formatISO(new Date()),
    }),
    format.splat(),
    format.simple(),
    format.printf(formatMessage),
  ),
  stderrLevels: ['error'],
});

const createCustomLogger = ({ label }: LoggerConfig): Logger => {
  const logger = createLogger({
    transports: [new transports.Console(consoleTransportOptions({ label }))],
  });

  return logger;
};

export default createCustomLogger;
